import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export default class Chat {
    key: string;
    count: number;
    unread: number;
    message: string;
    created: Date;

    constructor(
        key: string,
        count: number,
        unread: number,
        message: string,
        created: Date
    ) {
        this.key = key;
        this.count = count;
        this.unread = unread;
        this.message = message;
        this.created = created;
    }

    public static readonly list = async (uuid: string, brand: string) =>
        (await axios
            .get(environment.api_url + "/" + brand + "/chat/list", {
                headers: {
                    "User-Token": uuid,
                },
            })
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as Chat[] | undefined;

    public static readonly info = async (
        uuid: string,
        brand: string,
        chat: string
    ) =>
        (await axios
            .get(environment.api_url + "/" + brand + "/chat/" + chat, {
                headers: {
                    "User-Token": uuid,
                },
            })
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as Chat | undefined;
}
